import React, { memo, useCallback, useContext, useState } from 'react';

import { Box, Flex, Stack } from '@chakra-ui/layout';
import { Button, SelectInput, TextInput, Unform } from 'components';
import ROPA from 'models/Forms/ROPA';
import { IROPAProps, ROPACtx } from 'pages';
import { checkPermission } from 'utils/authentication';

import { SecurityIncidentsData } from 'constants/tooltips';
const Item: React.FC<IROPAProps> = ({ functionCallback, index, submit, completed }) => {
  const ctx = useContext(ROPACtx);

  const [loading, setLoading] = useState(false);

  const handleSubmit = useCallback(
    async (data: ROPA) => {
      localStorage.setItem('load', String(Math.random()));

      setLoading(true);
      if (submit) {
        const resp = await submit(data, '7 - Incidentes de Segurança');
        if (resp) {
          functionCallback(index + 1);
        }
      } else {
        functionCallback(index + 1);
      }
      setLoading(false);
    },
    [submit, functionCallback, index],
  );

  return (
    <Flex marginTop="1rem" width="100%" direction="column">
      <Unform
        initialData={ctx.data}
        onSubmit={handleSubmit}
        // validationSchema={SecurityIncidentsValidationSchema}
      >
        {checkPermission({ onlyAdmin: true }) ? (
          <>
            <Box>
              <SelectInput
                tip={SecurityIncidentsData[0].label}
                label="Já ocorreu algum incidente?"
                name="hasIncident"
                options={[
                  { name: 'Sim', value: 'yes' },
                  { name: 'Não', value: 'no' },
                ]}
                optionLabel="name"
                optionValue="value"
                // {...cProps}
              />
            </Box>
            <Box>
              <TextInput
                tip={SecurityIncidentsData[1].label}
                label="Link para a documentação relativa ao incidente"
                name="linkToDocIncident"
                // {...cProps}
              />
            </Box>
            {!ctx.isDetails && (
              <Box width="100%">
                <Stack direction={['column', 'row']} spacing="1rem" mt="1rem" justify="flex-end">
                  <Button
                    type="button"
                    variant="primary"
                    outline
                    onClick={() => functionCallback(index - 1)}
                  >
                    Voltar
                  </Button>
                  <Button
                    type="submit"
                    variant="primary"
                    // onClick={nextPage}
                    isLoading={loading}
                    disabled={loading}
                  >
                    Próximo
                  </Button>
                </Stack>
              </Box>
            )}
            {ctx.isDetails && (
              <Box width="100%">
                <Stack direction={['column', 'row']} spacing="1rem" mt="1rem" justify="flex-end">
                  <Button
                    type="button"
                    variant="primary"
                    outline
                    onClick={() => functionCallback(index - 1)}
                  >
                    Voltar
                  </Button>
                  <Button
                    type="submit"
                    variant="primary"
                    // onClick={nextPage}
                    isLoading={loading}
                    disabled={loading}
                  >
                    Próximo
                  </Button>
                </Stack>
              </Box>
            )}
          </>
        ) : (
          <>
            <Box>
              <SelectInput
                tip={SecurityIncidentsData[0].label}
                label="Já ocorreu algum incidente?"
                name="hasIncident"
                options={[
                  { name: 'Sim', value: 'yes' },
                  { name: 'Não', value: 'no' },
                ]}
                optionLabel="name"
                optionValue="value"
                isDisabled={completed}
              />
            </Box>
            <Box>
              <TextInput
                tip={SecurityIncidentsData[1].label}
                label="Link para a documentação relativa ao incidente"
                name="linkToDocIncident"
                isDisabled={completed}
              />
            </Box>
            {!completed && (
              <Box width="100%">
                <Stack direction={['column', 'row']} spacing="1rem" mt="1rem" justify="flex-end">
                  <Button
                    type="button"
                    variant="primary"
                    outline
                    onClick={() => functionCallback(index - 1)}
                  >
                    Voltar
                  </Button>
                  <Button
                    type="submit"
                    variant="primary"
                    // onClick={nextPage}
                    isLoading={loading}
                    disabled={loading}
                  >
                    Concluir
                  </Button>
                </Stack>
              </Box>
            )}
          </>
        )}
      </Unform>
    </Flex>
  );
};

export const SecurityIncidents = memo(Item);
